import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";
import Calculator from "@/views/Calculator.vue";
import GenePanel from "@/views/GenePanel.vue";
import Supplementary from "@/views/Supplementary.vue";

import RiskPlots from "@/components/RiskStrata";

Vue.use(VueRouter);

export default new VueRouter({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/supplementary",
      name: "supplementary",
      component: Supplementary
    },
    {
      path: "/gene-panel",
      name: "gene-panel",
      component: GenePanel
    },
    {
      path: "/stratification",
      name: "stratification",
      component: RiskPlots
    },
    {
      path: "/calculator",
      name: "calculator",
      component: Calculator
    }
  ]
});
